import React from 'react';
import { useIntl } from 'hooks/intl';
import { FpFormattedMessage } from 'locales/FpFormattedMessage';
import { FpSimpleConfirm } from '../FpSimpleConfirm';

export interface FpLayoutEditLeaveConfirmProps {
  onConfirm: () => void
  onClose: () => void
}

export function FpLayoutEditLeaveConfirm(props: FpLayoutEditLeaveConfirmProps) {
  const intl = useIntl();

  return (
    <FpSimpleConfirm
      title={intl.formatMessage('dialog.layoutEdit.title')}
      onClose={props.onClose}
      onConfirm={props.onConfirm}
    >
      <div><FpFormattedMessage id="dialog.layoutEdit.message.leave" /></div>
      <div><FpFormattedMessage id="dialog.layoutEdit.message.confirm" /></div>
    </FpSimpleConfirm>
  );
}
